import { createSelector } from 'reselect';


export const getOverview = ({dashboardState}) => dashboardState.overview;
export const getOrders = ({dashboardState}) => dashboardState.orders;
export const getFilteredOrders = ({dashboardState}) => dashboardState.filters;
export const getProds = ({dashboardState}) => dashboardState.prods;
export const isLoading = ({dashboardState}) => dashboardState.loading;
export const total = ({dashboardState}) => dashboardState.total;
